const now = +(new Date())
let index = 0

export default function uid () {
  return `vc-upload-${now}-${++index}`
}



// WEBPACK FOOTER //
// ./components/vc-upload/src/uid.js